export const aiLearningStrategyData = [
  // Profil entreprise
  {
    id: 1,
    category: "Profil entreprise",
    question: "Quel est le secteur principal de votre activité ?",
    responses: [
      "Industrie",
      "Services", 
      "Éducation",
      "Santé",
      "Public",
      "Autres"
    ]
  },
  {
    id: 2,
    category: "Profil entreprise",
    question: "Combien de salariés compte votre entreprise ?",
    responses: [
      "<10",
      "10-50",
      "51-200", 
      "201-1000",
      ">1000"
    ]
  },
  {
    id: 3,
    category: "Profil entreprise",
    question: "Votre entreprise est-elle multi-sites ?",
    responses: [
      "Oui",
      "Non"
    ]
  },

  // ═══════════════════════════════════════════
  // PILIER : STRATÉGIE (#FD41A6)
  // ═══════════════════════════════════════════
  {
    id: 4,
    category: "Stratégie",
    question: "Avez-vous une vision stratégique claire sur l'intégration de l'IA dans votre politique formation ?",
    responses: [
      "Oui, formalisée",
      "Partiellement",
      "En réflexion",
      "Non",
      "Ne sais pas"
    ],
    scores: [3, 2, 1, 0, 0]
  },
  {
    id: 5,
    category: "Stratégie",
    question: "Vos formations sont-elles alignées sur des objectifs business mesurables ?",
    responses: [
      "Oui, systématiquement",
      "Parfois",
      "Rarement",
      "Non",
      "Ne sais pas"
    ],
    scores: [3, 2, 1, 0, 0]
  },
  {
    id: 6,
    category: "Stratégie",
    question: "Un budget spécifique est-il dédié à l'innovation pédagogique ou à l'IA ?",
    responses: [
      "Oui",
      "Partiellement",
      "En cours de définition",
      "Non",
      "Ne sais pas"
    ],
    scores: [3, 2, 1, 0, 0]
  },
  {
    id: 7,
    category: "Stratégie",
    question: "Le volet formation dispose-t-il d'un sponsor ou référent IA identifié ?",
    responses: [
      "Oui",
      "En cours de désignation",
      "En réflexion",
      "Non",
      "Ne sais pas"
    ],
    scores: [3, 2, 1, 0, 0]
  },
  {
    id: 8,
    category: "Stratégie",
    question: "La direction est-elle impliquée dans les projets IA Learning ?",
    responses: [
      "Oui, activement",
      "Ponctuellement",
      "Faiblement",
      "Non",
      "Ne sais pas"
    ],
    scores: [3, 2, 1, 0, 0]
  },

  // ═══════════════════════════════════════════
  // PILIER : DÉPLOIEMENT (#FF6600)
  // ═══════════════════════════════════════════
  {
    id: 9,
    category: "Déploiement",
    question: "Disposez-vous d'un LMS, LCMS ou LXP pour gérer vos parcours et le suivi des apprenants ?",
    responses: [
      "Oui",
      "En cours de déploiement",
      "En réflexion",
      "Non",
      "Ne sais pas"
    ],
    scores: [3, 2, 1, 0, 0]
  },
  {
    id: 10,
    category: "Déploiement",
    question: "Les processus administratifs de formation sont-ils automatisés (convocations, attestations, relances) ?",
    responses: [
      "Oui",
      "Partiellement",
      "En projet",
      "Non",
      "Ne sais pas"
    ],
    scores: [3, 2, 1, 0, 0]
  },
  {
    id: 11,
    category: "Déploiement",
    question: "Les obligations Qualiopi sont-elles gérées de manière centralisée et digitale ?",
    responses: [
      "Oui",
      "Partiellement",
      "En projet",
      "Non",
      "Ne sais pas"
    ],
    scores: [3, 2, 1, 0, 0]
  },
  {
    id: 12,
    category: "Déploiement",
    question: "Le suivi des compétences ou acquis est-il structuré et mesuré dans un outil dédié ?",
    responses: [
      "Oui",
      "Partiellement",
      "En cours",
      "Non",
      "Ne sais pas"
    ],
    scores: [3, 2, 1, 0, 0]
  },
  {
    id: 13,
    category: "Déploiement",
    question: "Des formations sont-elles accessibles à la demande (catalogue asynchrone) ?",
    responses: [
      "Oui, un catalogue complet",
      "Quelques-unes",
      "En projet",
      "Non",
      "Ne sais pas"
    ],
    scores: [3, 2, 1, 0, 0]
  },

  // ═══════════════════════════════════════════
  // PILIER : PRODUCTION (#43B4E8)
  // ═══════════════════════════════════════════
  {
    id: 14,
    category: "Production",
    question: "Les modalités pédagogiques sont-elles diversifiées (vidéo, quiz, podcast, simulations…) ?",
    responses: [
      "Oui, très diversifiées",
      "Moyennement",
      "Peu",
      "Très peu",
      "Ne sais pas"
    ],
    scores: [3, 2, 1, 0, 0]
  },
  {
    id: 15,
    category: "Production",
    question: "Utilisez-vous l'IA pour concevoir des parcours pédagogiques (cours, évaluations, quiz, études de cas…) ?",
    responses: [
      "Oui, régulièrement",
      "Occasionnellement",
      "Rarement",
      "Jamais",
      "Ne sais pas"
    ],
    scores: [3, 2, 1, 0, 0]
  },
  {
    id: 16,
    category: "Production",
    question: "Utilisez-vous l'IA pour produire des vidéos de formation (génération, doublage, traduction) ?",
    responses: [
      "Oui",
      "En expérimentation",
      "En réflexion",
      "Non",
      "Ne sais pas"
    ],
    scores: [4, 2, 1, 0, 0]
  },
  {
    id: 17,
    category: "Production",
    question: "Utilisez-vous l'IA pour générer des visuels de formation (illustrations, avatars, assets 3D…) ?",
    responses: [
      "Oui",
      "En expérimentation",
      "En réflexion",
      "Non",
      "Ne sais pas"
    ],
    scores: [4, 2, 1, 0, 0]
  },
  {
    id: 18,
    category: "Production",
    question: "Disposez-vous de capacités de production multimédia en interne (vidéo, motion, voiceover) ?",
    responses: [
      "Oui, une équipe dédiée",
      "Quelques compétences",
      "Uniquement en externe",
      "Non",
      "Ne sais pas"
    ],
    scores: [3, 2, 1, 0, 0]
  },
  {
    id: 19,
    category: "Production",
    question: "Vos contenus sont-ils optimisés mobile & accessibilité ?",
    responses: [
      "Oui",
      "Partiellement",
      "En projet",
      "Non",
      "Ne sais pas"
    ],
    scores: [3, 2, 1, 0, 0]
  },

  // ═══════════════════════════════════════════
  // PILIER : PILOTAGE (#FFBF25)
  // ═══════════════════════════════════════════
  {
    id: 20,
    category: "Pilotage",
    question: "Mesurez-vous l'impact des formations sur les performances métiers ?",
    responses: [
      "Oui, systématiquement",
      "Parfois",
      "Rarement",
      "Non",
      "Ne sais pas"
    ],
    scores: [3, 2, 1, 0, 0]
  },
  {
    id: 21,
    category: "Pilotage",
    question: "Avez-vous défini des KPI précis pour chaque parcours de formation ?",
    responses: [
      "Oui",
      "Pour certains parcours",
      "En réflexion",
      "Non",
      "Ne sais pas"
    ],
    scores: [3, 2, 1, 0, 0]
  },
  {
    id: 22,
    category: "Pilotage",
    question: "Le reporting formation est-il partagé avec les managers et/ou le CODIR ?",
    responses: [
      "Oui, régulièrement",
      "Occasionnellement",
      "Rarement",
      "Jamais",
      "Ne sais pas"
    ],
    scores: [3, 2, 1, 0, 0]
  },
  {
    id: 23,
    category: "Pilotage",
    question: "Croisez-vous les résultats de formation avec d'autres données internes (ventes, production, sécurité…) ?",
    responses: [
      "Oui",
      "Parfois",
      "En projet",
      "Non",
      "Ne sais pas"
    ],
    scores: [3, 2, 1, 0, 0]
  },
  {
    id: 24,
    category: "Pilotage",
    question: "Un cadre d'usage de l'IA est-il défini pour les équipes formation ?",
    responses: [
      "Oui, formalisé",
      "En cours de définition",
      "En réflexion",
      "Non",
      "Ne sais pas"
    ],
    scores: [3, 2, 1, 0, 0]
  },

  // ═══════════════════════════════════════════
  // PILIER : FORMATION ET CHANGE (#10B981)
  // ═══════════════════════════════════════════
  {
    id: 25,
    category: "Formation et change",
    question: "Vos équipes pédagogiques sont-elles formées aux usages de l'IA ?",
    responses: [
      "Oui",
      "En cours",
      "En réflexion",
      "Non",
      "Ne sais pas"
    ],
    scores: [3, 2, 1, 0, 0]
  },
  {
    id: 26,
    category: "Formation et change",
    question: "Les craintes ou réticences face à l'IA sont-elles prises en compte dans votre accompagnement au changement ?",
    responses: [
      "Oui, avec un plan dédié",
      "Partiellement",
      "En réflexion",
      "Non",
      "Ne sais pas"
    ],
    scores: [3, 2, 1, 0, 0]
  },
  {
    id: 27,
    category: "Formation et change",
    question: "Les collaborateurs disposent-ils de temps pour expérimenter des outils IA ?",
    responses: [
      "Oui",
      "Parfois",
      "Rarement",
      "Non",
      "Ne sais pas"
    ],
    scores: [3, 2, 1, 0, 0]
  },
  {
    id: 28,
    category: "Formation et change",
    question: "Avez-vous mis en place des chatbots pédagogiques ou des assistants IA pour les apprenants ?",
    responses: [
      "Oui",
      "En expérimentation",
      "En réflexion",
      "Non",
      "Ne sais pas"
    ],
    scores: [3, 2, 1, 0, 0]
  },
  {
    id: 29,
    category: "Formation et change",
    question: "Des pilotes IA-based learning sont-ils déjà en place ou prévus prochainement ?",
    responses: [
      "Oui, en production",
      "En cours de pilotage",
      "En réflexion",
      "Non",
      "Ne sais pas"
    ],
    scores: [3, 2, 1, 0, 0]
  }
];

// Mapping des catégories pour l'affichage
export const learningCategoryMapping: Record<string, string> = {
  "Profil entreprise": "Profil entreprise",
  "Stratégie": "Stratégie",
  "Déploiement": "Déploiement",
  "Production": "Production",
  "Pilotage": "Pilotage",
  "Formation et change": "Formation et change"
};

// Explications contextuelles pour chaque catégorie
export const categoryExplanations: Record<string, string> = {
  "Profil entreprise": "Cette dimension permet de contextualiser votre évaluation selon votre secteur d'activité, taille et organisation.",
  "Stratégie": "Évaluez l'alignement stratégique entre votre politique formation et vos ambitions IA : vision, sponsorship, budget et gouvernance.",
  "Déploiement": "Mesurez le niveau de digitalisation de vos processus de formation : outils, automatisation, conformité et accès aux contenus.",
  "Production": "Analysez vos capacités de conception et de production de contenus pédagogiques, y compris l'usage de l'IA pour la création multimédia.",
  "Pilotage": "Évaluez votre capacité à mesurer l'impact des formations, piloter les KPI et partager les résultats avec les parties prenantes.",
  "Formation et change": "Mesurez la maturité de vos équipes face à l'IA : adoption, accompagnement au changement, expérimentation et montée en compétences."
};

// Configuration des piliers avec couleurs et images
export const pillarConfig: Record<string, { color: string; image: string; pillar: string }> = {
  "Stratégie": { color: "#FD41A6", image: "nokodia-vision.webp", pillar: "Vision" },
  "Déploiement": { color: "#FF6600", image: "nokodia-flow.webp", pillar: "Flow" },
  "Production": { color: "#8B5CF6", image: "nokodia-production.webp", pillar: "Production" },
  "Pilotage": { color: "#FFBF25", image: "nokodia-focus.webp", pillar: "Focus" },
  "Formation et change": { color: "#43B4E8", image: "nokodia-empowerment.webp", pillar: "Empowerment" }
};
